import { dmnIdentity } from "../../utils/dmnIdentity";
import { getEnvironmentProps } from "../../utils/environment";
import { errorHandler, throwApiError } from "../errorHandler";
import { collinsApiHeaders } from "../getDefaultHeaders";
import { readJsonBody } from "../responseBody";
import { VenueGroupConfig } from "../../types/VenueGroup";

export type OrganisationOption = {
  _id: string;
  title: string;
};

type OrganisationsResponse = {
  data: OrganisationOption[];
};

export const fetchOrganisations = async (): Promise<OrganisationOption[]> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  const response = await fetch(
    `${environmentVars?.COLLINS_API_BASE_URL}/venue-groups?fields=title`,
    {
      cache: "no-store",
      method: "GET",
      headers: {
        ...collinsApiHeaders(token),
        "cache-control": "no-store",
        source: "admin"
      }
    }
  );

  if (!response.ok) {
    await throwApiError(response, "Error fetching organisations");
  }

  const responseData = await readJsonBody<OrganisationsResponse>(response);
  return responseData?.data ?? [];
};

export const fetchOrganisationById = async (organisationId: string) => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  try {
    const response = await fetch(
      `${environmentVars?.CORE_API_BASE_URL}/venue-groups/${organisationId}?extend_users=false&extend_venues=false`,
      {
        cache: "no-store",
        method: "GET",
        headers: {
          ...collinsApiHeaders(token),
          "cache-control": "no-store",
          source: "admin"
        }
      }
    );

    if (!response.ok) {
      await throwApiError(response, "Error fetching organisation config");
    }

    const responseData = await readJsonBody<{
      payload?: { venueGroup?: VenueGroupConfig };
    }>(response);
    return responseData?.payload;
  } catch (error) {
    await errorHandler(error, "Error fetching organisation config");
    return null;
  }
};
